import { FormEvent, useState } from 'react';
import { IconArrowRight, IconShield } from './icons';
import { Field } from './ui';
import { api, ApiError } from '../lib/api';
import { t } from '../lib/i18n';

/** Second step of every sign-in path when the account has 2FA: authenticator code or a recovery code. */
export function MfaStep({ token, onDone }: { token: string; onDone: () => void }) {
  const [code, setCode] = useState('');
  const [recovery, setRecovery] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api.post('/auth/mfa', { mfa_token: token, code });
      onDone();
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.code === 'INVALID_TOKEN'
            ? t('Время на ввод кода вышло. Войдите заново.')
            : err.code === 'RATE_LIMITED'
              ? t('Слишком много попыток. Подождите минуту.')
              : err.message
          : t('Сеть недоступна.'),
      );
      setCode('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="stack" onSubmit={submit}>
      <div className="row" style={{ color: 'var(--spray)' }}>
        <IconShield size={22} />
        <strong style={{ color: '#fff' }}>{t('Двухфакторный вход')}</strong>
      </div>
      <Field label={recovery ? t('Код восстановления') : t('Код из приложения')} hint={recovery ? t('Формат xxxxx-xxxxx, каждый код работает один раз') : t('Шесть цифр из Google Authenticator, 1Password и т.п.')}>
        <input
          className="input input-mono"
          style={{ fontSize: 20, letterSpacing: recovery ? 2 : 8, textAlign: 'center' }}
          inputMode={recovery ? 'text' : 'numeric'}
          autoComplete="one-time-code"
          maxLength={recovery ? 20 : 6}
          value={code}
          onChange={(e) => setCode(recovery ? e.target.value : e.target.value.replace(/\D/g, ''))}
          autoFocus
          required
        />
      </Field>
      {error && <div className="callout bad">{error}</div>}
      <button className="btn btn-primary btn-lg" disabled={busy || (recovery ? code.length < 10 : code.length !== 6)}>
        {busy ? t('Проверяем…') : t('Подтвердить')} <IconArrowRight size={16} />
      </button>
      <button type="button" className="btn btn-ghost btn-sm" onClick={() => (setRecovery(!recovery), setCode(''))}>
        {recovery ? t('Ввести код из приложения') : t('Нет доступа к телефону? Код восстановления')}
      </button>
    </form>
  );
}
